import styled from 'styled-components'

const StyledAdminLoginAsUserView = styled.div`
  padding: 60px;
`

export default StyledAdminLoginAsUserView
